var _path, _path2, _path3, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1818 4.20837L3.81818 4.20837C3.56714 4.20837 3.36364 4.41358 3.36364 4.66671L3.36364 21.1667C3.36364 21.4198 3.56714 21.625 3.81818 21.625L20.1818 21.625C20.4329 21.625 20.6364 21.4198 20.6364 21.1667L20.6364 4.66671C20.6364 4.41358 20.4329 4.20837 20.1818 4.20837ZM3.81818 2.83337C2.81403 2.83337 2 3.65419 2 4.66671L2 21.1667C2 22.1792 2.81403 23 3.81818 23L20.1818 23C21.186 23 22 22.1792 22 21.1667L22 4.66671C22 3.65419 21.186 2.83337 20.1818 2.83337L3.81818 2.83337Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.13654 1C8.5131 1 8.81836 1.3078 8.81836 1.6875L8.81836 4.89583C8.81836 5.27553 8.5131 5.58333 8.13654 5.58333C7.75998 5.58333 7.45472 5.27553 7.45472 4.89583L7.45472 1.6875C7.45472 1.3078 7.75998 1 8.13654 1Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3182 1C16.6947 1 17 1.3078 17 1.6875L17 4.89583C17 5.27553 16.6947 5.58333 16.3182 5.58333C15.9416 5.58333 15.6364 5.27553 15.6364 4.89583L15.6364 1.6875C15.6364 1.3078 15.9416 1 16.3182 1Z",
    fill: "black"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.54532,
    cy: 9.91667,
    rx: 0.909091,
    ry: 0.916666,
    fill: "black"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.9999,
    cy: 9.91667,
    rx: 0.909091,
    ry: 0.916666,
    fill: "black"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.4545,
    cy: 9.91667,
    rx: 0.909091,
    ry: 0.916666,
    fill: "black"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.54532,
    cy: 13.5833,
    rx: 0.909091,
    ry: 0.916667,
    fill: "black"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.9999,
    cy: 13.5833,
    rx: 0.909091,
    ry: 0.916667,
    fill: "black"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.4545,
    cy: 13.5833,
    rx: 0.909091,
    ry: 0.916667,
    fill: "black"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.54532,
    cy: 17.2499,
    rx: 0.909091,
    ry: 0.916667,
    fill: "black"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.9999,
    cy: 17.2499,
    rx: 0.909091,
    ry: 0.916667,
    fill: "black"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.4545,
    cy: 17.2499,
    rx: 0.909091,
    ry: 0.916667,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.e12666b9bb4f4ad75bc891c929188a27.svg";
export { ForwardRef as ReactComponent };